import { createFileRoute } from '@tanstack/react-router'

// e2e fixture (spec 2026-10-06-09): a page that throws on render, on a bare
// route (no application chrome, see isExternalCounterpartyRoute).
export const Route = createFileRoute('/test/bare/crash')({
  component: CrashingBarePage,
})

function CrashingBarePage(): never {
  throw new Error('Intentional bare test crash')
}
